import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { Mail, ArrowRight } from 'lucide-react'
import { useGetInbox } from '../../hooks/backend/customerInbox'

export default function CustomerInboxSummary() {
  const inbox = useGetInbox()
  const [data, setData] = useState<{ needs_reply: number; overdue: number; unmatched: number } | null>(null)
  const [error, setError] = useState(false)
  useEffect(() => {
    let active = true
    const load = () => {
      void inbox.trigger({}, { skipCache: true }).then((r: unknown) => {
        if (active) { setData(r as typeof data); setError(false) }
      }).catch(() => { if (active) setError(true) })
    }
    load()
    const timer = window.setInterval(() => { if (document.visibilityState === 'visible') load() }, 60000)
    return () => { active = false; clearInterval(timer) }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return <Link to="/inbox" className="flex flex-wrap items-center gap-3 rounded-lg border bg-card p-4 hover:bg-accent/50 transition-colors">
    <div className="rounded-full bg-primary/10 text-primary p-2"><Mail className="w-5 h-5" /></div>
    <div className="flex-1"><p className="font-semibold">Customer inbox {data ? `· ${data.needs_reply} need replies` : ''}</p>
      <p className="text-sm text-muted-foreground">{error ? 'Open inbox to check the connection.' : data ? `${data.overdue} older than 24 hours · ${data.unmatched} unmatched conversations` : 'Checking customer conversations…'}</p></div>
    <span className="text-sm font-medium flex items-center gap-1">Review replies <ArrowRight className="w-4 h-4" /></span>
  </Link>
}
